import { render, staticRenderFns } from "./PopularPhraseItem.vue?vue&type=template&id=62fd2c5a&scoped=true&"
import script from "./PopularPhraseItem.vue?vue&type=script&lang=ts&"
export * from "./PopularPhraseItem.vue?vue&type=script&lang=ts&"
import style0 from "./PopularPhraseItem.vue?vue&type=style&index=0&id=62fd2c5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fd2c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62fd2c5a')) {
      api.createRecord('62fd2c5a', component.options)
    } else {
      api.reload('62fd2c5a', component.options)
    }
    module.hot.accept("./PopularPhraseItem.vue?vue&type=template&id=62fd2c5a&scoped=true&", function () {
      api.rerender('62fd2c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/items/PopularPhraseItem.vue"
export default component.exports